module.exports = __webpack_public_path__ + "static/img/about3.afa9886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/about3.jpg
// module id = vIeO
// module chunks = 3